import React from 'react';
import PropTypes from 'prop-types';

import './table-body.scss';

export class TableBody extends React.PureComponent {
  static propTypes = {
    data: PropTypes.array,
    config: PropTypes.object.isRequired,
    dataTestId: PropTypes.string,
  };

  static defaultProps = {
    data: [],
    dataTestId: null,
  };

  renderRow = (item, index, config) => {
    const {
      columnsConfig = [],
      trClassName = '',
      trClickCallback = () => {},
    } = config;
    const { dataTestId } = this.props;

    return (
      <tr
        className={`tr ${trClassName}`}
        onClick={() => trClickCallback(item)}
        key={index}
        data-testid={
          dataTestId
            ? `${dataTestId}-table-row-${index + 1}`
            : `table-row-${index + 1}`
        }
      >
        {columnsConfig.map((configItem, index) => {
          if (!(configItem.name in item)) {
            return (
              <td
                key={index}
                className={`tr__td word-break ${configItem.tdClass || ''}`}
                data-testid={`table-cell-${index}`}
              />
            );
          }
          return (
            <td
              key={index}
              className={`tr__td word-break ${configItem.tdClass || ''}`}
              data-testid={`table-cell-${configItem.name
                .toLowerCase()
                .replace(' ', '-')}`}
            >
              {item[configItem.name]}
            </td>
          );
        })}
      </tr>
    );
  };

  render() {
    const { data, config } = this.props;

    return (
      <tbody className="table-body">
        {data.map((item, index) => this.renderRow(item, index, config))}
      </tbody>
    );
  }
}
